// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserAuthPages_temp__fpkrD {
    border-radius: 20.188px;
    box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);
    background-color: var(--Primary, #E7ECEF);
    display: flex;
    flex-direction: column;
    height: 100%;
}

.UserAuthPages_temp14__OCl5\\+ {
    align-self: center;
    margin-top: 33px;
    margin-bottom: 83px;
    width: 100%;
    max-width: 1466px;
    padding-right: 20px;
    padding-left: 20px;
    @media (max-width: 991px) {
    maxWidth: "100%",
    }
}

.UserAuthPages_link__sa0bf {
    color: aqua;
}

.UserAuthPages_temp15__Z8Y\\+\\+ {
    gap: 20px;
    display: flex;
    justify-content: center;
    @media (max-width: 991px) {
        flex-direction: column;
        align-items: stretch;
        gap: 0px
    };
}

.UserAuthPages_loanOfficer__l8r5V {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 50%;
    margin-left: 0px;
    font-size: 32px;
    justify-content: center;
    @media (max-width: 991px) {
        margin-left: 0;
    }
}

.UserAuthPages_loanOfficerCard__aqEnN {
    border-radius: 16.842px;
    box-shadow:
        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
    display: flex;
    margin-right: auto;
    flex-grow: 1;
    padding-top: 17px;
    padding-right: 20px;
    padding-bottom: 40px;
    padding-left: 20px;
    flex-direction: column;
    width: 90%;
    justify-content: center;
    @media (max-width: 991px) {
        max-width: 100%;
        margin-top: 50px;
    }
}

.UserAuthPages_loanOfficerInfo__I7KQT{
    justify-content: left;
    font-family:
        Lato, sans-serif;
        margin-top: 10px;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: var(--half-secondary, #516F91);
}

.UserAuthPages_createAccount__I9-eh {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 47%;
    height: 70%;
    margin-left: 0px;
    @media (max-width: 991px) {
    marginLeft: 0,
    }
}

.UserAuthPages_forgotPasswordLink__AnEfb {
    justify-content: left;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 25px;
    font-weight: 700;
    align-self: start;
    margin-top: 25px
}

.UserAuthPages_temp20__5IOjb {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 35%;
    margin-left: 20px;
    @media (max-width: 991px) {
    width: "100%";
    marginLeft: 0;
    }
}

.UserAuthPages_forgotPasswordCard__u4nWa {
    border-radius: 16.842px;
    box-shadow:
        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #F8F8FB);
    display: flex;
    margin-right: auto;
    flex-grow: 1;
    padding-top: 40px;
    padding-right: 20px;
    padding-bottom: 40px;
    padding-left: 20px;
    flex-direction: column;
    width: 100%;
    height: 717px;
    @media (max-width: 991px) {
        maxWidth: "100%";
        marginTop: "50px"
    }
}

.UserAuthPages_temp21__DvEua {
    align-self: center;
    display: flex;
    margin-top: 22px;
    margin-left: -12px;
    margin-bottom: 72px;
    width: 472px;
    max-width: 100%;
    flex-direction: column
}

.UserAuthPages_temp22__zYSVi {
    align-self: end;
    display: flex;
    margin-right: 9px;
    width: 463px;
    max-width: 100%;
    flex-direction: column;
}

.UserAuthPages_forgotPassword__EL-9D {
    justify-content: center;
    color: var(--half-secondary, #516F91);
    font-family:
    Lato, sans-serif;
    font-size: 32px;
    font-weight: 700;
    align-self: start;
    max-width: 317px;
}

.UserAuthPages_forgotPasswordInfo__TY5el {
    color: #000;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family:
    Poppins, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 137.5%;
    opacity: 0.4;
    align-self: start;
    margin-top: 52px;
    width: 382px;
    max-width: 100%;
}

.UserAuthPages_email__AH9\\+w {
    color: #000;
    margin-top: 10px;
    opacity: 70%;
    text-align: left;
    margin-left: 20px;
}

.UserAuthPages_signInInput__eT\\+QF {
    padding: 10px;
    font-size: 18px;
    border-width: 1px;
    border-color: #000000;
    background-color: #ffffff;
    color: #000000;
    border-style: solid;
    border-radius: 35px;
    display: flex;
    width: 90%;
    padding-left: 20px;
    padding-right: 60px;
}

.UserAuthPages_inputDiv__HL88g {
    margin-left: 3%;
    width: 90%;
    margin-top: 10px;
}

.UserAuthPages_dropdown__fFNOL {
    padding: 10px;
    font-size: 18px;
    border-width: 1px;
    border-color: #000000;
    background-color: #ffffff;
    color: #000000;
    border-style: solid;
    border-radius: 35px;
    display: flex;
    width: 90%;
    padding-left: 20px;
    padding-right: 60px;
}

.UserAuthPages_selectBox__rwD-F{
    width:100%;
    height:100%;
    border:0px;
    outline:none;
}


.UserAuthPages_signInBtn__R6Tp1 {
    background-color: #0a96e5;
    font-size: 26px;
    width: 90%;
    height: 65px;
    border-radius: 16.84px;
    box-shadow: 0px 20.210939407348633px 40.42px -6.74px rgba(39, 76, 119, 0.16);
    font-weight: 600;
    color: #ffffff;
    border-color: #0a96e5;
    cursor: pointer;
    margin-top: 5%;
    margin-left: 3%;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserAuthPages.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wEAAwE;IACxE,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB;IACA;IACA;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB;QACI,sBAAsB;QACtB,oBAAoB;QACpB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB;oEACgE;IAChE,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB;wBACoB;QAChB,gBAAgB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB;IACA;IACA;AACJ;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC;wBACoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB;IACA,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB;oEACgE;IAChE,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC;oBACgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C;uBACmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,4EAA4E;IAC5E,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":[".temp {\n    border-radius: 20.188px;\n    box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);\n    background-color: var(--Primary, #E7ECEF);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.temp14 {\n    align-self: center;\n    margin-top: 33px;\n    margin-bottom: 83px;\n    width: 100%;\n    max-width: 1466px;\n    padding-right: 20px;\n    padding-left: 20px;\n    @media (max-width: 991px) {\n    maxWidth: \"100%\",\n    }\n}\n\n.link {\n    color: aqua;\n}\n\n.temp15 {\n    gap: 20px;\n    display: flex;\n    justify-content: center;\n    @media (max-width: 991px) {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0px\n    };\n}\n\n.loanOfficer {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 50%;\n    margin-left: 0px;\n    font-size: 32px;\n    justify-content: center;\n    @media (max-width: 991px) {\n        margin-left: 0;\n    }\n}\n\n.loanOfficerCard {\n    border-radius: 16.842px;\n    box-shadow:\n        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n    display: flex;\n    margin-right: auto;\n    flex-grow: 1;\n    padding-top: 17px;\n    padding-right: 20px;\n    padding-bottom: 40px;\n    padding-left: 20px;\n    flex-direction: column;\n    width: 90%;\n    justify-content: center;\n    @media (max-width: 991px) {\n        max-width: 100%;\n        margin-top: 50px;\n    }\n}\n\n.loanOfficerInfo{\n    justify-content: left;\n    font-family:\n        Lato, sans-serif;\n        margin-top: 10px;\n    font-size: 20px;\n    font-weight: 700;\n    text-align: left;\n    color: var(--half-secondary, #516F91);\n}\n\n.createAccount {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 47%;\n    height: 70%;\n    margin-left: 0px;\n    @media (max-width: 991px) {\n    marginLeft: 0,\n    }\n}\n\n.forgotPasswordLink {\n    justify-content: left;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 25px;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 25px\n}\n\n.temp20 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 35%;\n    margin-left: 20px;\n    @media (max-width: 991px) {\n    width: \"100%\";\n    marginLeft: 0;\n    }\n}\n\n.forgotPasswordCard {\n    border-radius: 16.842px;\n    box-shadow:\n        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #F8F8FB);\n    display: flex;\n    margin-right: auto;\n    flex-grow: 1;\n    padding-top: 40px;\n    padding-right: 20px;\n    padding-bottom: 40px;\n    padding-left: 20px;\n    flex-direction: column;\n    width: 100%;\n    height: 717px;\n    @media (max-width: 991px) {\n        maxWidth: \"100%\";\n        marginTop: \"50px\"\n    }\n}\n\n.temp21 {\n    align-self: center;\n    display: flex;\n    margin-top: 22px;\n    margin-left: -12px;\n    margin-bottom: 72px;\n    width: 472px;\n    max-width: 100%;\n    flex-direction: column\n}\n\n.temp22 {\n    align-self: end;\n    display: flex;\n    margin-right: 9px;\n    width: 463px;\n    max-width: 100%;\n    flex-direction: column;\n}\n\n.forgotPassword {\n    justify-content: center;\n    color: var(--half-secondary, #516F91);\n    font-family:\n    Lato, sans-serif;\n    font-size: 32px;\n    font-weight: 700;\n    align-self: start;\n    max-width: 317px;\n}\n\n.forgotPasswordInfo {\n    color: #000;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family:\n    Poppins, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 137.5%;\n    opacity: 0.4;\n    align-self: start;\n    margin-top: 52px;\n    width: 382px;\n    max-width: 100%;\n}\n\n.email {\n    color: #000;\n    margin-top: 10px;\n    opacity: 70%;\n    text-align: left;\n    margin-left: 20px;\n}\n\n.signInInput {\n    padding: 10px;\n    font-size: 18px;\n    border-width: 1px;\n    border-color: #000000;\n    background-color: #ffffff;\n    color: #000000;\n    border-style: solid;\n    border-radius: 35px;\n    display: flex;\n    width: 90%;\n    padding-left: 20px;\n    padding-right: 60px;\n}\n\n.inputDiv {\n    margin-left: 3%;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.dropdown {\n    padding: 10px;\n    font-size: 18px;\n    border-width: 1px;\n    border-color: #000000;\n    background-color: #ffffff;\n    color: #000000;\n    border-style: solid;\n    border-radius: 35px;\n    display: flex;\n    width: 90%;\n    padding-left: 20px;\n    padding-right: 60px;\n}\n\n.selectBox{\n    width:100%;\n    height:100%;\n    border:0px;\n    outline:none;\n}\n\n\n.signInBtn {\n    background-color: #0a96e5;\n    font-size: 26px;\n    width: 90%;\n    height: 65px;\n    border-radius: 16.84px;\n    box-shadow: 0px 20.210939407348633px 40.42px -6.74px rgba(39, 76, 119, 0.16);\n    font-weight: 600;\n    color: #ffffff;\n    border-color: #0a96e5;\n    cursor: pointer;\n    margin-top: 5%;\n    margin-left: 3%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"temp": `UserAuthPages_temp__fpkrD`,
	"temp14": `UserAuthPages_temp14__OCl5+`,
	"link": `UserAuthPages_link__sa0bf`,
	"temp15": `UserAuthPages_temp15__Z8Y++`,
	"loanOfficer": `UserAuthPages_loanOfficer__l8r5V`,
	"loanOfficerCard": `UserAuthPages_loanOfficerCard__aqEnN`,
	"loanOfficerInfo": `UserAuthPages_loanOfficerInfo__I7KQT`,
	"createAccount": `UserAuthPages_createAccount__I9-eh`,
	"forgotPasswordLink": `UserAuthPages_forgotPasswordLink__AnEfb`,
	"temp20": `UserAuthPages_temp20__5IOjb`,
	"forgotPasswordCard": `UserAuthPages_forgotPasswordCard__u4nWa`,
	"temp21": `UserAuthPages_temp21__DvEua`,
	"temp22": `UserAuthPages_temp22__zYSVi`,
	"forgotPassword": `UserAuthPages_forgotPassword__EL-9D`,
	"forgotPasswordInfo": `UserAuthPages_forgotPasswordInfo__TY5el`,
	"email": `UserAuthPages_email__AH9+w`,
	"signInInput": `UserAuthPages_signInInput__eT+QF`,
	"inputDiv": `UserAuthPages_inputDiv__HL88g`,
	"dropdown": `UserAuthPages_dropdown__fFNOL`,
	"selectBox": `UserAuthPages_selectBox__rwD-F`,
	"signInBtn": `UserAuthPages_signInBtn__R6Tp1`
};
export default ___CSS_LOADER_EXPORT___;
